// extracted by mini-css-extract-plugin
export default {"line":"PatchnoteForm_line__XUcbY","label":"PatchnoteForm_label__yGBAt","error":"PatchnoteForm_error__1k4WA"};